import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Image from 'common/src/components/Image';
import Heading from 'common/src/components/Heading';
import Button from 'common/src/components/Button';
import FeatureBlock from 'common/src/components/FeatureBlock';
import Container from 'common/src/components/UI/Container';
import Particles from '../Particle';
import BannerWrapper, {
  DiscountLabel,
  BannerObject
} from './bannerSection.style';

import BannerObject1 from 'common/src/assets/image/saas/banner/bannerObject1.png';
import BannerObject2 from 'common/src/assets/image/saas/banner/Calculator.png';

const BannerMessage = styled.a`
  position: fixed;
  top: 56px;
  left: 0;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #5268db;
  color: white;
  z-index: 9999;
  a {
    color: white;
    &:hover,
    &:visited {
      color: white;
    }
  }
  @media screen and (max-width: 500px) {
    padding: 10px;
    height: 60px;
    font-size: 14px;
  }
`;

const BannerSection = ({
  row,
  col,
  title,
  btnStyle,
  description,
  discountText,
  discountAmount,
  outlineBtnStyle
}) => {
  const ButtonGroup = () => (
    <Fragment>
      <a href="https://app.myloansense.com/advisor-signup">
        <Button title="Financial Advisor Portal" {...btnStyle} />
      </a>
      <a href="https://app.myloansense.com/client-signup">
        <Button
          className="outlined"
          title="Client Portal"
          variant="outlined"
          {...outlineBtnStyle}
        />
      </a>
    </Fragment>
  );
  return (
    <BannerWrapper id="banner_section">
      <Particles />
      <Container>
        {/* <BannerMessage href="/d2cwebinar">
          Confused about how the COVID-19 relief bill affects your student
          loans? Sign up for a free webinar here.
        </BannerMessage> */}
        <Box className="row" {...row}>
          <Box className="col" {...col}>
            {/* <DiscountLabel>
              <Text content="25% Discount" {...discountAmount} />
              <Text content="on every first project " {...discountText} />
            </DiscountLabel> */}
            <FeatureBlock
              title={
                <Heading
                  content="LoanSense - Financial Advisors Loan Expert"
                  {...title}
                />
              }
              description={
                <>
                  <Text
                    content="<strong>Boost</strong> referrals with ease and <strong>grow</strong> your financial planning business.
                    "
                    {...description}
                  />
                  <br />
                  <Text
                    content="Address the #1 financial concern of this generation: student loan debt."
                    {...description}
                  />
                  <br />
                  <Text
                    content="Turn-key solution to build your student loan practice in minutes"
                    {...description}
                  />
                </>
              }
              button={<ButtonGroup />}
            />
          </Box>
        </Box>
      </Container>
      <BannerObject>
        <div className="objectWrapper">
          <Image src={BannerObject1} alt="BannerObject1" />
          <div className="dashboardWrapper">
            <Image
              style={{ marginTop: '100px' }}
              src={BannerObject2}
              alt="BannerObject2"
            />
          </div>
        </div>
      </BannerObject>
    </BannerWrapper>
  );
};

BannerSection.propTypes = {
  title: PropTypes.object,
  btnStyle: PropTypes.object,
  description: PropTypes.object,
  contentStyle: PropTypes.object,
  discountText: PropTypes.object,
  discountAmount: PropTypes.object,
  outlineBtnStyle: PropTypes.object
};

BannerSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center'
  },
  col: {
    pr: '15px',
    pl: '15px',
    width: [1, '70%', '50%', '45%']
  },
  title: {
    fontSize: ['22px', '34px', '30px', '55px'],
    fontWeight: '700',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: ['20px', '25px'],
    lineHeight: '1.5'
  },
  description: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '0'
  },
  btnStyle: {
    minWidth: ['120px', '120px', '120px', '156px'],
    fontSize: ['13px', '14px'],
    fontWeight: '500',
    colors: 'primaryWithBg'
  },
  outlineBtnStyle: {
    minWidth: '156px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#5167db',
    ml: '18px'
  },
  discountAmount: {
    fontSize: '14px',
    color: '#eb4d4b',
    mb: 0,
    as: 'span',
    mr: '0.4em',
    fontWeight: 700
  },
  discountText: {
    fontSize: ['13px', '14px'],
    color: '#0f2137',
    mb: 0,
    as: 'span',
    fontWeight: 500
  }
};

export default BannerSection;
